import React from 'react';
import { useInstance } from 'react-ioc';
import { observer } from 'mobx-react';
import styles from './SchoolLogo.module.scss';
import { SchoolStore } from 'stores';
import { combineClasses, FileProvider } from '@axl/accel-framework/utils';
import { AccelLogo } from '@axl/accel-framework/components';

type SchoolLogoProps = {
    theme?: 'light' | 'dark';
    className?: string;
    imageClassname?: string;
    height?: number;
    width?: number;
}

const SchoolLogo: React.FC<SchoolLogoProps> = ({ theme, height, width, className, imageClassname }) => {
    const store = useInstance(SchoolStore);
    const fileProvider = useInstance(FileProvider);

    return <div className={combineClasses('flex flex-center', className)}>
        {store.school.logo
            ? <img src={fileProvider.getUrl(store.school.logo)} className={combineClasses(styles.custom_logo, imageClassname)} style={{ height, width }}></img>
            : <AccelLogo theme={theme} width={width} height={height} />}
    </div>;
}
SchoolLogo.defaultProps = {
    theme: 'light',
    height: 40
}
export default observer(SchoolLogo);